export function optimizeMailBody(body: string): string {
    const parts = body.split('<div id="appendonsend">');
    let cleanedContent = parts[0]; // Ne prendre que la première partie

    // Supprimer les balises de style et de script
    cleanedContent = cleanedContent
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
        .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "");

    // Supprimer les adaptive cards
    cleanedContent = cleanedContent.replace(
        /<div[^>]*itemprop="signedAdaptiveCard"[^>]*>[\s\S]*?<\/div>/gi,
        "",
    );

    // Supprimer les balises HTML mais conserver leur contenu
    cleanedContent = cleanedContent.replace(/<[^>]+>/g, " ");

    // Supprimer les espaces multiples
    cleanedContent = cleanedContent.replace(/\s+/g, " ");

    // Supprimer les espaces en début et fin de chaîne
    cleanedContent = cleanedContent.trim();

    // Supprimer les lignes vides
    cleanedContent = cleanedContent.replace(/^\s*[\r\n]/gm, "");

    // eslint-disable-next-line no-useless-escape
    cleanedContent = cleanedContent.replace(/\&nbsp;/g, "");

    // Limiter à 2000 caractères
    cleanedContent = cleanedContent.substring(0, 2000);

    return cleanedContent;
}
